import { ForwardedRef, forwardRef } from "react";
import styles from "./RadioButtonArea.module.scss";
import useForwardRef from "../../../../hooks/useForwardRef";
import RadioButton from "./radio-button/RadioButton";

export type RadioButtonOption = {
	key: any;
	label: string;
	value: any;
};

type Props = {
	children?: React.ReactNode;
	label: string;
	initialValue?: any;
	required?: boolean;
	options?: RadioButtonOption[];
	onChange: (value: any) => void;
};

const RadioButtonArea = forwardRef((props: Props, ref: ForwardedRef<HTMLInputElement>) => {
	const { children, label, onChange, required, options, initialValue } = props;
	const forwardedRef = useForwardRef(ref);


	const handleContainerClick = () => {
		if (forwardedRef?.current) {
			forwardedRef.current.focus();
		}
	};

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            handleContainerClick();
        }
    };

	return (
		<div
			className={`${styles.inputContainer} `}
			onClick={handleContainerClick}
			onKeyDown={handleKeyDown} 
			role="button" 
			tabIndex={0} 
			aria-label={label}
		>
			<div className={`${styles.inputIcon} ${styles.orangeBg}`}>{children}</div>
			<div className={styles.inputContent}>
				<span className={styles.inputLabel}>
					{label} {required && <div className={styles.asterix}>&nbsp;*</div>}
				</span>
				<div className={styles.optionsContainer}>
					{options?.map((x, i) => (
						<RadioButton key={i} initialValue={initialValue} onChangeValue={onChange} selectedValue={x.value} text={x.label} />
					))}
				</div>
			</div>
		</div>
	);
});

export default RadioButtonArea;
